import { AttachmentTypes } from './../enums/attachment-types';

export class Attachment {
  attachmentType: AttachmentTypes;
  title: string;
  description: string;
  attachmentId: string;
}
